<template>
  <v-dialog v-model="show" width="786px" persistent>
    <!-- <template v-slot:activator="{ on }"> </template> -->
    <div class="modal">
      <v-card flat :loading="status_action === 'loading'">
        <ValidationObserver ref="validator">
          <v-row>
            <div class="icon-modal table-cell">
              <v-layout class="delete-warning-icon">
                <v-flex>
                  <img :src="require('@/assets/img/warning.svg')" alt=""/>
                </v-flex>
              </v-layout>
            </div>
            <v-col class="table-cell modal-content">
              <div class="d-flex justify-space-between">
                <h6 class="modal-title mb-5">Delete Vendor Company</h6>
              </div>

              <p>This Vendor company and their employees will no longer have the ability to access Kiey (The app or Vendor Admin panel).</p>

              <b>Are you sure you wish to delete this vendor?</b>

              <div class="mt-10 mb-10 buttons d-flex">
                <v-btn
                    class="mt-5 mr-6 btn-blanco few"
                    rounded
                    depressed
                    @click="delete_vendor"
                    :loading="status_action === 'loading'"
                    :disabled="status_action === 'loading'"
                >Yes
                </v-btn>
                <v-btn
                    class="mt-5 btn-azul few"
                    rounded
                    depressed
                    @click="hide"
                    :loading="status_action === 'loading'"
                    :disabled="status_action === 'loading'"
                >No
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </ValidationObserver>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
  import {mapState} from "vuex";
  import {ValidationObserver} from "vee-validate";

  export default {
    props: ['show', 'hide', 'selected'],
    components: {ValidationObserver},
    computed: {
      ...mapState({
        status_action: state => state.Users_list.status_action,
      }),
    },
    methods:
      {
        close: function () {
          this.hide();
        },
        setter() {
          const self = this;
          self.$emit("setter");
        },
        async delete_vendor() {
          const self = this;
          self.$store.dispatch('Users_list/delete_vendor', {
            transfer_to: "not_transfer",
            users: self.selected,
            disable_account: true
          }).then(function (response) {
            if (response) {
              self.close();
              self.setter();
            }
          });

        }
      }
    ,
  };
</script>